import React from 'react';
import * as PropTypes from 'prop-types';
import {checkSpanStyles, labelStyles, outerDivStyles, outerSpanStyles, spanStyles} from "../../styles/Toggle.css";



const Toggle = (props) => {

  let onClick = () => {
    if(props.disabled)
      return;
    props.toggleSelected(props.name);
  };

  return (
    <div style={outerDivStyles}>
      <span style={outerSpanStyles}>
    <label style={labelStyles(props.checked, props.disabled)}>
      <span style={checkSpanStyles(props.checked)}></span>
      <span style={spanStyles(props.disabled)} onClick={onClick}></span>
    </label>
      </span>
    </div>
  )
};

Toggle.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  toggleSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Toggle;